<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="showDialog"
      max-width="270"
    >
    <v-card v-if="showDialog === true">
    <v-toolbar dense>
      <v-toolbar-title style="font-family: 'Pacifico', cursive; overflow:visible; font-size:0.8em;">{{activeImage.name}} <span v-if="activeImage.cost !== undefined && activeImage.cost !== ''"> - {{activeImage.cost}}</span></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="showDialog=false"><v-icon>clear</v-icon></v-btn>
    </v-toolbar>
    <img :src="activeImage.src" style="width: 100%"/>
    <v-toolbar dense>
      <v-btn icon @click="lastImage"><v-icon>keyboard_arrow_left</v-icon></v-btn>
      <v-spacer></v-spacer>
      <v-btn icon @click="nextImage"><v-icon>keyboard_arrow_right</v-icon></v-btn>
    </v-toolbar>
    </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: ['show', 'images', 'index'],
  data () {
    return {
      showDialog: false,
      activeIndex: -1
    }
  },
  watch: {
    show (val) {
      this.showDialog = val
    },
    index (val) {
      this.activeIndex = val
    },
    showDialog (val) {
      this.$emit('visible', val)
    }
  },
  computed: {
    activeImage () {
      return this.images[this.activeIndex]
    }
  },
  methods: {
    nextImage () {
      if (this.images[this.activeIndex + 1] !== undefined) {
        this.activeIndex++
      } else {
        this.activeIndex = 0
      }
    },
    lastImage () {
      if (this.images[this.activeIndex - 1] !== undefined) {
        this.activeIndex--
      } else {
        this.activeIndex = this.images.length - 1
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Gallery.vue